import { render } from "./Industri.vue?vue&type=template&id=76cbb648"
import script from "./Industri.vue?vue&type=script&lang=js"
export * from "./Industri.vue?vue&type=script&lang=js"

import "./Industri.vue?vue&type=style&index=0&id=76cbb648&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__